import { PrivateRoomAdminDetails } from "@/features/private-room/list/layouts/private-room-admin-details";
import { useLoaderData, useNavigate } from "react-router-dom";
import { LoaderData } from "./private-room-admin-details-loader";

export const PrivateRoomAdminDetailsRoute = () => {
  const { privateRoom, isLoading, daysSinceUpdate } =
    useLoaderData() as LoaderData;
  const navigate = useNavigate();

  const handleClose = () => {
    navigate("/private-office/admin");
  };

  return (
    <PrivateRoomAdminDetails
      privateRoom={privateRoom}
      isOpen={true}
      onClose={handleClose}
      isLoading={isLoading}
      daysSinceUpdate={daysSinceUpdate}
    />
  );
};
